/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/es/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/es/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/es/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/es/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/es/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/es/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/es/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/es/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/es/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/es/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/es/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/es/preview-05.webp'),
    },
  ],
};
